import { Fragment } from "react";
import Head from "next/head";
import ContentCard from "@/components/UI/content-card/content_card";
import style from "./style.module.css";

export default function TermAndCondition() {
  return (
    <Fragment>
      <Head>
        <title>ข้อตลงและเงื่อนไข บริษัท ทีคิวเอ็ม โบรกเกอร์ จำกัด(มหาชน)</title>
      </Head>
      <section className={style.term_and_condition_section}>
        <div className={style.bg_strip}></div>
        <div className={style.term_and_condition_container}>
          <ContentCard>
            <h1>คำแถลงเกี่ยวกับการรักษาข้อมูลส่วนบุคคล</h1>
            <h2>ข้อตกลงและเงื่อนไข</h2>
            <p>
              รายละเอียดนโยบายของ บริษัท ทีคิวเอ็ม อินชัวร์รันส์ โบรคเกอร์
              จำกัด, บริษัท ทีคิวเอ็ม ไลฟ์ อินชัวร์รันส์ โบรคเกอร์ จำกัด บริษัท
              แคสแมท จำกัด, บริษัท ทีเจเอ็น อินชัวร์รันส์ โบรกเกอร์ จำกัด และ
              บริษัท อีซี่ เลนดิ้ง จำกัด เกี่ยวกับการเก็บรวบรวม
              ใช้และ/หรือเปิดเผยข้อมูลส่วนบุคคลของลูกค้า
              กรุณาอ่านและ/หรือทำความเข้าใจในเงื่อนไข และข้อตกลงในการใช้บริการ
              ก่อนกดปุ่ม “ยอมรับ”
            </p>
            <h2>การเคารพสิทธิในความเป็นส่วนตัวของท่าน</h2>
            <p>
              บริษัท ทีคิวเอ็ม อินชัวร์รันส์ โบรคเกอร์ จำกัด, บริษัท ทีคิวเอ็ม
              ไลฟ์ อินชัวร์รันส์ โบรคเกอร์ จำกัด, บริษัท แคสแมท จำกัด, บริษัท
              ทีเจเอ็น อินชัวร์รันส์ โบรกเกอร์ จำกัด และ บริษัท อีซี่ เลนดิ้ง
              จำกัด (ต่อไปในที่นี้รวมเรียกว่า “บริษัทฯ”)
              มีความตระหนักดีว่าท่านมีความประสงค์ที่จะได้รับความปลอดภัยสูงสุดในสิทธิความเป็นส่วนตัวของท่าน
              บริษัทฯ จึงให้ความสำคัญ และ เคารพสิทธิในความเป็นส่วนตัวของท่าน
              ในการดำเนินการเก็บรวมรวม ใช้
              ประมวลผลและเปิดเผยข้อมูลส่วนบุคคลที่สามารถระบุตัวตนของท่านได้
              อาจรวมถึงชื่อ สัญชาติ ที่อยู่ ข้อมูลของลักษณะที่อยู่อาศัย
              หมายเลขโทรศัพท์ หมายเลขโทรสาร รายละเอียดบัญชีธนาคาร
              รายละเอียดบัตรเครดิต ความสนใจส่วนบุคคล ที่อยู่ E-mail Address
              ภาพถ่ายของท่าน หมายเลขประจำตัวที่ราชการออกให้แก่ท่าน ข้อมูลชีวภาพ
              เชื้อชาติ วันเกิด สถานะการสมรส ข้อมูลของสมาชิกในครอบครัว ศาสนา
              ข้อมูลสุขภาพ ข้อมูลยานพาหนะ และการประกันภัย โดยบริษัทฯ
              จะดำเนินการโดยใช้มาตรการที่เข้มงวดในการรักษาความปลอดภัยตามวัตถุประสงค์ที่ได้แจ้งให้ท่านทราบ
              และ/หรือที่ท่านได้ให้ความยินยอมไว้เท่านั้น
              ตลอดจนป้องกันมิให้มีการนำข้อมูลส่วนบุคคลของท่านไปใช้โดยมิได้รับการอนุญาตจากท่านก่อน
            </p>
            <h2>การเก็บรวบรวมข้อมูลส่วนบุคคล</h2>
            <h3>
              วัตถุประสงค์และ
              การให้ข้อมูลส่วนบุคคลเพื่อปฏิบัติามกฎหมายหรือสัญญาหรือมีความจำเป็นต้องให้ข้อมูลส่วนบุคคล
            </h3>
            <p>
              บริษัทฯ มีวัตถุประสงค์ขอเก็บรวบรวม ใช้
              หรือเปิดเผยข้อมูลส่วนบุคคลของท่าน
              เพื่อนําเสนอข้อมูลเกี่ยวกับผลิตภัณฑ์และบริการ
              รวมทั้งเพื่อการปรับปรุง พัฒนา
              และเพื่อคงไว้ซึ่งคุณภาพของผลิตภัณฑ์และบริการ
              ที่เจ้าของข้อมูลส่วนบุคคลเป็นคู่สัญญากับบริษัท
              และเพื่อการติดต่อสื่อสาร เช่น การส่งบริการแจ้งเตือน
              การตอบกลับเมื่อได้รับการติดต่อจากเจ้าของข้อมูล
              สำหรับข้อมูลส่วนบุคคลที่มีความละเอียดอ่อน เช่น ชื่อ นามสกุล
              ที่อยู่ เบอร์โทรศัพท์ วัน เดือน ปีเกิด หมายเลขบัตรประจำตัวประชาชน
              สถานะการสมรส เป็นต้น
              เพื่อปฏิบัติตามกฎหมายหรือสัญญาหรือมีความจำเป็นต้องให้ข้อมูลส่วนบุคคลเพื่อการเข้าทำสัญญาตามความจำเป็นเท่านั้น
            </p>
            <p>
              บริษัทฯ
              จะดำเนินการใช้ข้อมูลส่วนบุคคลของท่านตามที่ระบุไว้อย่างระมัดระวัง
              และใช้มาตรการกำกับดูแลการปฏิบัติตามเงื่อนไขและข้อกำหนด นโยบาย
              และจรรยาบรรณของบริษัทฯ ในการดำเนินการปฏิบัติ ตรวจสอบ ป้องกัน
              และดำเนินคดีตามกฎหมาย
              รวมถึงการใช้ข้อมูลส่วนบุคคลเพื่อแก้ปัญหาด้านการสนับสนุนลูกค้า
            </p>
            <p>
              สำหรับวัตถุประสงค์ทางกฎหมาย บริษัทฯ
              อาจใช้ข้อมูลส่วนบุคคลที่บริษัทฯ
              เก็บรวบรวมเพื่อสอบสวนและยุติคำร้องเรียน หรือระงับข้อพิพาท
              หรือตามที่ได้รับอนุญาตหรือต้องกระทำตามกฎหมายที่บังคับใช้ บริษัทฯ
              อาจใช้ข้อมูลส่วนบุคคลของท่านเมื่อบริษัทฯ ต้องได้รับคำปรึกษา
              ได้รับคำแนะนำ หรือถูกร้องขอให้กระทำเช่นนั้น โดยที่ปรึกษาทางกฎหมาย
              หรือโดยหน่วยงานทางกฎหมาย รัฐบาล
              หรือหน่วยงานราชการอื่นทั้งในประเทศและต่างประเทศ
            </p>
            <h2>ข้อมูลที่ขอจัดเก็บ</h2>
            <p>
              บริษัทฯ จะดำเนินการจัดเก็บ ใช้ และเปิดเผยข้อมูลส่วนบุคคลโดยมี
              วัตถุประสงค์ ขอบเขต และใช้วิธีการที่ชอบด้วยกฎหมายและเป็นธรรม
              โดยในการเก็บรวบรวมนั้นจะทำเพียงเท่าที่จำเป็นแก่การดำเนินงานภายใต้วัตถุประสงค์ของบริษัทเท่านั้น
              ทั้งนี้ บริษัทจะดำเนินการแจ้งให้เจ้าของข้อมูลทราบรายละเอียด
              หรือให้ความยินยอมก่อนในเว็บไชต์การขายประกันภัยประเภทต่าง ๆ
              (แล้วแต่กรณี) ตามแบบวิธีการของบริษัท
              และตามที่พระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562
              หรือกฎหมายอื่นกำหนดไว้
            </p>
            <h2>ระยะเวลาในการเก็บ รวบรวม ใช้และ เปิดเผยข้อมูล</h2>
            <p>
              เป็นเวลา 10 ปี นับจากวันที่ได้รับความยินยอม
              หรือได้มีการเก็บรวบรวมข้อมูลโดยชอบด้วยกฎหมาย
              หลังจากนั้นบริษัทจะทำลายข้อมูลดังกล่าวตามวิธีการที่ได้มาตรฐาน
              เว้นแต่เป็นกรณีที่บริษัทฯ
              มีหน้าที่ตามกฎหมายในการเก็บรักษาข้อมูลนั้น ๆ ไว้ต่อไป
              หรือเพื่อเป็นการคุ้มครองสิทธิของบริษัทฯ ตามระยะเวลาที่กฎหมายกำหนด
            </p>
            <h2>
              ความจำเป็นต้องเปิดเผยข้อมูลส่วนบุคคลของท่านที่เก็บรวบรวมไว้ให้แก่บุคคลหรือหน่วยงานอื่น
            </h2>
            <p>
              ภายใต้วัตถุประสงค์ที่ได้แจ้งให้ท่านทราบ
              หรือที่ท่านได้ให้ความยินยอมแก่บริษัทฯ แล้ว บริษัทฯ
              อาจมีความจำเป็นต้องดำเนินการเปิดเผยข้อมูลส่วนบุคคลของท่านที่เก็บรวบรวมไว้ให้แก่บุคคลหรือหน่วยงานอื่นเฉพาะกลุ่มบริษัทในเครือ
              บริษัทลูก บริษัทที่เกี่ยวข้องกัน และ
              บริษัทที่อยู่ภายใต้การควบคุมเดียวกัน รวมถึงองค์กร หน่วยงานของรัฐ
              หรือบุคคลภายนอกซึ่งรวมถึงตัวแทน ผู้ค้า ผู้จัดหา พาร์ทเนอร์
              ผู้รับจ้าง ผู้ให้บริการภายนอก
            </p>
            <p>
              ทั้งนี้ บริษัทฯ
              จะดำเนินการตามขั้นตอนที่เหมาะสมเพื่อปกป้องและป้องกันมิให้เกิดการสูญหาย
              การเข้าถึงข้อมูลโดยไม่ได้รับอนุญาต การใช้ การดัดแปลง
              หรือการเปิดเผยที่ไม่ชอบด้วยกฎหมาย โดยบุคคลที่บริษัทฯ
              เปิดเผยข้อมูลส่วนบุคคลให้ทราบดังกล่าวข้างต้น
            </p>
            <p>
              อนึ่ง ในกรณีที่บริษัทฯ
              ต้องเปิดเผยข้อมูลส่วนบุคคลต่อผู้รับข้อมูลในต่างประเทศ บริษัทฯ
              จะดำเนินการเปิดเผยข้อมูลส่วนบุคคลเฉพาะในกรณีที่ท่านได้ให้ความยินยอม
              หรือที่กฎหมายคุ้มครองข้อมูลส่วนบุคคล
              และกฎหมายอื่นที่เกี่ยวข้องกําหนดให้ทําได้เท่านั้น
            </p>
            <h3>สิทธิที่เกี่ยวกับข้อมูลของท่าน</h3>
            <p>
              ท่านสามารถใช้สิทธิที่เกี่ยวกับข้อมูลของท่านโดยใช้ความเป็นของเจ้าของข้อมูลส่วนบุคคลของท่านตามที่บริษัทฯ
              แจ้งท่าน ไว้ในหนังสือฉบับนี้
            </p>
            <ul>
              <li>
                1.
                สิทธิในการเพิกถอนความยินยอมในการประมวลผลข้อมูลส่วนบุคคลที่ได้ให้ความยินยอมไว้
                และสิทธิในการได้รับแจ้งในกรณีที่บริษัทฯ
                ทำการเก็บรวบรวมข้อมูลส่วนบุคคล
              </li>
              <li>
                2. สิทธิขอเข้าถึงและขอรับสำเนาข้อมูลของท่าน
                รวมถึงการขอให้เปิดเผยการได้มาซึ่งข้อมูลส่วนบุคคลที่ไม่ได้ให้ความ
                ยินยอม
              </li>
              <li>
                3. สิทธิการขอให้บริษัทฯ
                ส่งข้อมูลของท่านไปยังผู้ควบคุมข้อมูลส่วนบุคคลรายอื่น
              </li>
              <li>
                4. สิทธิการขอคัดค้าน การเก็บ รวบรวม ใช้ หรือเปิดเผยข้อมูลใดๆ
                ที่เคยอนุญาตไว้ก่อนหน้านั้นแล้ว เจ้าของข้อมูลมี
                สิทธิขอคัดค้านภายหลังได้
              </li>
              <li>
                5. สิทธิขอให้บริษัทฯ ดำเนินการลบหรือทำลายข้อมูลของท่าน
                เว้นแต่กรณีที่บริษัทฯ ต้องปฏิบัติตามกฎหมายที่
                เกี่ยวข้องในการเก็บรักษาข้อมูลดังกล่าว
              </li>
              <li>
                6. สิทธิขอให้บริษัทฯ
                ดำเนินการแก้ไขข้อมูลที่ไม่ถูกต้องหรือไม่สมบูรณ์
                และทำให้ข้อมูลเป็นปัจจุบัน
              </li>
              <li>
                7. สิทธิการขอระงับใช้ข้อมูล เพื่อไม่ให้บริษัทฯ
                นำข้อมูลของท่านไปประมวลผล เว้นแต่กรณีที่บริษัทฯ
                มีสิทธิประมวลผลข้อมูลของท่านต่อไปเพื่อปฏิบัติหน้าที่ตามสัญญาระหว่างบริษัทและท่าน
                หรือโดยอาศัยสิทธิอันชอบด้วยกฎหมายอื่น
              </li>
            </ul>
            <h3>สิทธิเพื่อการถอนความยินยอม</h3>
            <p>
              ท่านสามารถใช้สิทธิของเจ้าของข้อมูลส่วนบุคคลในการถอนความยินยอมเมื่อใดก็ได้
              โดยท่านสามารถแจ้งมายังบริษัทฯ ตามสถานที่และวิธีการติดต่อที่บริษัทฯ
              แจ้งให้ท่านทราบไว้ในหนังสือฉบับนี้
            </p>
            <h3>สถานที่ติดต่อ และวิธีการติดต่อ</h3>
            <p>
              ในกรณีที่ท่านต้องการความช่วยเหลือจากบริษัทฯ
              ไม่ว่าในกรณีเกี่ยวกับข้อมูลเพิ่มเติม ความผิดพลาด ข้อสงสัยใดๆ ที่
              เกิดขึ้นโดยไม่ได้รับอนุญาตจากท่าน ท่านสามารถติดต่อบริษัทฯ
              ได้ดังนี้https://www.tqm.co.th/ หรือทางอีเมล : dpo@tqm.co.th
            </p>
            <h2>การใช้ข้อมูลส่วนบุคคล</h2>
            <p>
              บริษัทฯ จะใช้ข้อมูลของท่านในการประกอบธุรกิจของบริษัทฯ
              ในด้านการส่งเสริมการขาย หรือการประชาสัมพันธ์ผลิตภัณฑ์ การ
              บริการต่าง ๆ รวมทั้งสิทธิประโยชน์ ข้อเสนอพิเศษต่าง ๆ
              ของผลิตภัณฑ์หรือบริการต่าง ๆ โดยเป็นไปเพื่อประโยชน์ของท่าน
            </p>
            <h2>
              การขอความยินยอมเพื่อดำเนินการเก็บรวมรวม
              ใช้ประมวลผลและเปิดเผยข้อมูล ส่วนบุคคลของท่าน
            </h2>
            <p>
              การขอความยินยอมในการเก็บรวบรวม ใช้
              และเปิดเผยข้อมูลส่วนบุคคลของท่าน บริษัทฯ
              ขอทราบคุณสมบัติของผู้ให้ข้อมูลเพื่อให้
              มั่นใจว่าท่านสามารถให้ข้อมูลส่วนบุคคลได้ตามที่กฎหมายกำหนด
              ข้าพเจ้าเป็นเจ้าของข้อมูลส่วนบุคคลสามารถให้ข้อมูลของตนได้โดยมิต้องขอความยินยอมจากบุคคลใด
              และมิได้เป็นผู้เยาว์ที่มีอายุไม่ เกินสิบปี หรือเป็นคนไร้ความสามารถ
              หรือเป็นคนเสมือนไร้ความสามารถ
              ในกรณีถ้าเจ้าของข้อมูลส่วนบุคคลเป็นผู้เยาว์มีอายุไม่เกินสิบปี
              บริษัทฯ ได้ขอความยินยอมจากผู้ใช้อำนาจปกครองที่มีอำนาจกระทำ
              การแทนผู้เยาว์หรือเป็นคนไร้ความสามารถ บริษัทฯ
              ได้ขอความยินยอมจากผู้อนุบาลที่มีอำนาจกระทำการแทนคนไร้ความสามารถ
              หรือเป็นคน เสมือนไร้ความสามารถ บริษัทฯ
              ได้ขอความยินยอมจากผู้พิทักษ์ที่มีอำนาจกระทำการแทนคนเสมือนไร้ความสามารถแล้ว
            </p>
            <h5>CS-MK-011164-006 </h5>
          </ContentCard>
        </div>
      </section>
    </Fragment>
  );
}
